module.exports = __webpack_public_path__ + "img/New PACI Flow - New User AR - 4.5891285b.png";